const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: ["/privacy",],
    exact: true,
    component: "PrivacyPolicy",
  },
  {
    path: ["/deleteaccount",],
    exact: true,
    component: "DeleteAccount",
  },
];

export default routes;
